import React, {FC}          from 'react';
import {HBox, VBox}         from '@sirius/ui-lib/src/blocks/Layout';
import {Icon}               from '@sirius/ui-lib/src/blocks/Controls';
import {SmtLocaleString}    from 'Smt/SmtLocaleBlock';
import {HintProps}          from './@types';
import {ICON_MODES}         from './values';
import {block}              from './block';
import './styles.less';


export const Hint: FC<HintProps> = (
    {
        messageK,
        icon,
        size,
        onClose,
        mode        = 'default',
        className   = ''
    }
) => (
    <HBox className={block + block.mod('mode', mode) + className}>
        <Icon className = {block.el('icon')}
              icon      = {icon ?? ICON_MODES[mode]}
              size      = {size}
        />
        <VBox className={block.el('message')}>
            <span className={block.el('message-text')}>
                <SmtLocaleString k      = {`${messageK}.message`}
                                 values = {{br: <br />}}
                                 id     = {'value'}
                />
            </span>
            <span className={block.el('message-subtext')}>
                <SmtLocaleString k      = {`${messageK}.submessage`}
                                 values = {{br: <br />}}
                                 id     = {'value'}
                />
            </span>
        </VBox>
        { onClose &&
            <Icon className = {block.el('action-close')}
                  icon      = {'close'}
                  size      = {size}
                  onClick   = {onClose}
            />
        }
    </HBox>
);
